import { Button } from "primereact/button"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import { useContext } from "react"
import { GpraContext } from "../../../context/gpraContext"
import gpraStyles from "../../../styles/Participant-GPRA.module.css"

const Previous = (props) => {
  const navigate = useNavigate()
  const { saveData, disabled } = props

  const { interviewType, handleActiveIndex, activeIndex, loadPrev } =
    useContext(GpraContext)

  const setPrevForm = (prevForm) => {
    const interview = interviewType.toLowerCase()
    if (prevForm === "recordMgmt") {
      navigate(`/participant/gpra-forms/${prevForm}`)
    } else {
      navigate(`/participant/gpra-forms/${interview}/${prevForm}`)
    }
  }
  const setNavigationItem = () => {
    let newActiveIndex = activeIndex - 1
    handleActiveIndex(newActiveIndex)
  }
  return (
    <Button
      label="Previous"
      icon={loadPrev ? "pi pi-spin pi-spinner" : "pi pi-arrow-left"}
      className={gpraStyles.mr1}
      onClick={() => {
        saveData(setPrevForm, true, setNavigationItem)
      }}
      disabled={disabled}
    />
  )
}

Previous.propTypes = {
  prevForm: PropTypes.string,
  saveData: PropTypes.func,
  disabled: PropTypes.bool,
}
export default Previous
